import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  Collapse,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
import {
  FiEdit3,
  FiPercent,
  FiChevronUp,
  FiChevronDown,
  FiCalendar,
} from "react-icons/fi";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function EditReservation() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isInfosGeneralesAccordionOpen, setIsInfosGeneralesAccordionOpen] =
    useState(true);
  const toggleInfosGeneralesAccordion = () =>
    setIsInfosGeneralesAccordionOpen((o) => !o);
  const [isRepartitionAccordionOpen, setIsRepartitionAccordionOpen] =
    useState(true);
  const toggleRepartitionAccordion = () =>
    setIsRepartitionAccordionOpen((o) => !o);
  const [
    isDetailsSouscriptionAccordionOpen,
    setIsDetailsSouscriptionAccordionOpen,
  ] = useState(true);
  const toggleDetailsSouscriptionAccordion = () =>
    setIsDetailsSouscriptionAccordionOpen((o) => !o);
  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
      marginTop: "-8px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "#fff", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [souscriptionData, setSoucriptionData] = useState([]);
  //meta title
  const urlParams = new URLSearchParams(window.location.search);

  const reservationId = urlParams.get("reservation_id");
  const reservationName = urlParams.get("reservation_name");
  const reservationInvestisseur = urlParams.get("reservation_investisseur");
  const reservationPartenaire = urlParams.get("reservation_partenaire");
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState({
    label: "En cours",
    value: 1,
  });
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/statuts_souscriptions`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setStatutData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  /************************* Partenaire *******************************/
  const [partenairesData, setPartenairesData] = useState({ data: [] });
  const [selectedPartenaire, setSelectedPartenaire] = useState("");
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/souscriptions/partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setPartenairesData(mode);
          if (reservationPartenaire != null) {
            const transformedPartenaires = mode.data.map((partenaire) => ({
              label: partenaire.label,
              value: partenaire.id,
            }));

            const selectedPartenaire = transformedPartenaires.find(
              (partenaire) => partenaire.value == reservationPartenaire
            );

            setSelectedPartenaire(selectedPartenaire);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: partenairesData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Partenaire *******************************/
  /*************************   Investisseurs  *******************************/
  const [investisseursData, setInvestisseursData] = useState({ data: [] });
  const [selectedInvestisseur, setSelectedInvestisseur] = useState("");
  const handleInvestisseurChange = (e) => {
    setSelectedInvestisseur(e);
  };
  const getInvestisseurs = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/investisseurs?partenaire_id=${
          selectedPartenaire?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setInvestisseursData(mode);
          if (reservationInvestisseur != null) {
            const transformedInvestisseurs = mode.data.map((investisseur) => ({
              label: investisseur.label,
              value: investisseur.id,
            }));

            const selectedInvestisseur = transformedInvestisseurs.find(
              (investisseur) => investisseur.value == reservationInvestisseur
            );

            setSelectedInvestisseur(selectedInvestisseur);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseursOptions = () => {
    return [
      {
        options: investisseursData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Investisseurs *******************************/
  /*************************   Catégorie PME  *******************************/
  const [selectedCategorie, setSelectedCategorie] = useState({
    label: "DOM COM",
    value: 1,
  });
  const [categorieData, setCategorieData] = useState({ data: [] });
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  const getCategories = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/natures_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((categorie) => {
          setCategorieData(categorie);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/pmes?natures_investissement_id=${selectedCategorie?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Reservation   *******************************/
  const [selectedReservation, setSelectedReservation] = useState("");
  const [reservationData, setReservationData] = useState({ data: [] });
  const handleReservationChange = (e) => {
    setSelectedReservation(e);
  };
  const getReservation = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/reservations?investisseur_id=${
          selectedInvestisseur?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setReservationData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderReservationOptions = () => {
    return [
      {
        options: reservationData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Reservation *******************************/
  /*************************   Taux d'apport  *******************************/
  const [selectedTaux, setSelectedTaux] = useState("");
  const [tauxData, setSelectedTauxData] = useState({ data: [] });
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/souscriptions/taux_apports`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux d'apport *******************************************/
  /*************************   Taux de reduction  *******************************/
  const [selectedTauxReduction, setSelectedTauxReduction] = useState("");
  const [TauxReductionData, setSelectedTauxReductionData] = useState({
    data: [],
  });
  const handleTauxReductionChange = (e) => {
    setSelectedTauxReduction(e);
  };
  const getTauxReduction = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/taux_reduction_impots`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxReductionData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxReductionOptions = () => {
    return [
      {
        options: TauxReductionData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux Reduc *******************************************/
  /*************************   Taux de reduction  *******************************/
  const [selectedTauxReductionA, setSelectedTauxReductionA] = useState("");
  const [TauxReductionAData, setSelectedTauxReductionDataA] = useState({
    data: [],
  });
  const handleTauxReductionAChange = (e) => {
    setSelectedTauxReductionA(e);
  };
  const getTauxReductionA = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/taux_reduction_impots2`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxReductionDataA(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxReductionAOptions = () => {
    return [
      {
        options: TauxReductionAData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux d'apport *******************************************/
  /*************************   Input *******************************/
  const [selectedMtReduction, setSelectedMtReduction] = useState("0");
  const handleMtReductionChange = (e) => {
    setSelectedMtReduction(e.target.value);
  };
  const [nbActionsMAx, setNbActionsMax] = useState();
  const [selectedNbAction, setSelectedNbAction] = useState("");
  const handleNbActionChange = (e) => {
    setSelectedNbAction(e.target.value);
  };
  const [selectedMtReservation, setSelectedMtReservation] = useState(0);
  const handleMtReservationChange = (e) => {
    setSelectedMtReservation(e.target.value);
  };
  const [selectedValeurAction, setSelectedValeurAction] = useState(0);
  const handleValeurActionChange = (e) => {
    setSelectedValeurAction(e.target.value);
  };

  const [selectedMtSouscription, setSelectedMtSouscription] = useState(0);
  const handleMtSouscriptionChange = (e) => {
    setSelectedMtSouscription(e.target.value);
  };

  const [selectedDateSouscription, setSelectedDateSouscription] = useState("");
  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Les mois sont de 0 à 11
    const year = today.getFullYear();

    return `${day}/${month}/${year}`;
  };

  // Utilisation de useEffect pour définir la date par défaut une fois que le composant est monté
  useEffect(() => {
    setSelectedDateSouscription(getCurrentDate());
  }, []);
  const [selectedNb_actions_ir, setSelectedNb_actions_ir] = useState("");
  const handleNbIrChange = (e) => {
    setSelectedNb_actions_ir(e.target.value);
  };
  const [selectedNb_actions_isf, setSelectedNb_actions_isf] = useState("");
  const handleNbIsfChange = (e) => {
    setSelectedNb_actions_isf(e.target.value);
  };
  /******************************* END Input *******************************************/
  /******************************* Mode de règlement *******************************************/
  const [selectedTranche, setSelectedTranche] = useState("");
  const [trancheData, setTrancheData] = useState({ data: [] });
  const handleTrancheChange = (e) => {
    setSelectedTranche(e);
  };

  const getTranche = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/souscriptions/tranchs?pme_id=${selectedPme?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setTrancheData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTrancheOptions = () => {
    return [
      {
        options: trancheData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* END Tranche *******************************************/

  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedPartenaire === null &&
      selectedStatut === null &&
      selectedTaux === null &&
      selectedCategorie === null
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else if (selectedPartenaire === null && selectedStatut === null) {
      toast.error("Le statut et le partenaire ne peuvent pas être vide");
    } else if (selectedTaux === null) {
      toast.error("Le taux ne peut pas être vide");
    } else if (selectedCategorie === null) {
      toast.error("La catégorie ne peut pas être vide");
    } else if (selectedPartenaire === null) {
      toast.error("Le partenaire ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/souscriptions/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              souscription: {
                id: id,
                investisseur_id: selectedInvestisseur?.value,
                pme_id: selectedPme?.value,
                tranch_id: selectedTranche?.value,
                date_souscription: selectedDateSouscription,
                nombre_actions: selectedNbAction,
                valeur_action: selectedValeurAction,
                montant_souscription: selectedMtSouscription,

                reservation_id: selectedReservation?.value,
                natures_investissement_id: selectedCategorie?.value,
                statuts_souscription_id: selectedStatut?.value,
                partenaire_id: selectedPartenaire?.value,
                montant_reduction_impot: selectedMtReduction,

                taux_apport_id: selectedTaux?.value,

                nb_actions_ir: selectedNb_actions_ir,
                nb_actions_isf: selectedNb_actions_isf,
                taux_reduction_impot_id: selectedTauxReduction?.value,
                taux_reduction_impot2_id: selectedTauxReductionA?.value,

                nb_actions_souscrites: selectedNbAction,
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          const responseData = await response.json();
          navigate(`${backUrl}/souscriptions/${responseData.id}`);
          // handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.souscription_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors = responseData?.souscription_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    if (reservationId && reservationData?.data) {
      const reservationOptions = renderReservationOptions()[0]?.options || [];
      const selectedOption = reservationOptions.find(
        (option) => option.value == reservationId
      );
      console.log(selectedOption);
      if (selectedOption) {
        setSelectedReservation(selectedOption); // Définit l'option correspondante
        setForceRender5(!forceRender5);
      }
    }

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [reservationData]);
  useEffect(() => {
    if (!loading) {
      getTranche();
      getPartenaire();
      getStatut();
      getTaux();

      getPme();
      getCategories();
      getTauxReduction();
      getTauxReductionA();
    }
  }, [loading, selectedCategorie, selectedPme]);
  useEffect(() => {
    if (!loading) {
      getInvestisseurs();
    }
  }, [loading, selectedPartenaire]);
  useEffect(() => {
    if (!loading) {
      getReservation();
    }
  }, [loading, selectedInvestisseur]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Souscriptions | New";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails souscription
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  /************************* Nb actions restantes *******************************/
  const [nbActionsRestantes, setNbActionsRestantes] = useState();
  const [forceRender, setForceRender] = useState(false);
  const [forceRender0, setForceRender0] = useState(false);
  const [forceRender1, setForceRender1] = useState(false);
  const [forceRender2, setForceRender2] = useState(false);
  const [forceRender3, setForceRender3] = useState(false);
  const [forceRender4, setForceRender4] = useState(false);
  const [forceRender5, setForceRender5] = useState(false);
  const [disableUseEffect, setDisableUseEffect] = useState(false);
  const getValue = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/update_values?nb_actions_souscrites=${selectedNbAction}&statuts_souscription_id=${
          selectedStatut?.value || ""
        }&tranch_id=${selectedTranche?.value || ""}&natures_investissement=${
          selectedCategorie?.value || ""
        }&pme_id=${selectedPme?.value || ""}&reservation_id=${
          selectedReservation?.value || ""
        }&taux_apport_id=${selectedTaux?.value || ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          setNbActionsRestantes(data?.restant_a_souscrire);
          setSelectedMtSouscription(data?.montant_souscription);
          setSelectedValeurAction(data?.valeur_action);
          setSelectedMtReservation(data?.montant_reservation_restant);
          setSelectedMtReduction(data?.montant_reduction_impot);
          setSelectedTaux(data?.taux_apport_id);

          setForceRender(!forceRender);
          setForceRender0(!forceRender0);

          setForceRender1(!forceRender1);
          setForceRender2(!forceRender2);
          setForceRender3(!forceRender3);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getValue();
    getTranche();
  }, [
    selectedTranche,
    selectedCategorie,
    selectedStatut,
    selectedNbAction,
    selectedPme,
    selectedReservation,
    //selectedTaux,
  ]);
  useEffect(() => {
    if (!loading) {
      setSelectedTranche(null);
      setForceRender4(!forceRender4);
    }
  }, [loading, selectedPme]);
  useEffect(() => {
    setNbActionsMax(Math.floor(selectedMtReservation / selectedValeurAction));
  }, [selectedMtReservation, selectedValeurAction]);
  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/souscriptions/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Souscriptions
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i> New
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to={`${backUrl}/souscriptions/`}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {/* Informations générales */}
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleInfosGeneralesAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Informations générales
                                      </span>
                                    </div>
                                    {isInfosGeneralesAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isInfosGeneralesAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Partenaire */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Partenaire
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedPartenaire}
                                                  onChange={
                                                    handlePartenaireChange
                                                  }
                                                  options={renderPartenaireOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedPartenaire === null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un partenaire..."
                                                />
                                                {(selectedPartenaire === null ||
                                                  selectedPartenaire ===
                                                    "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Partenaire ne peut pas être
                                                    vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Investisseur */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Investisseur
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedInvestisseur}
                                                  onChange={
                                                    handleInvestisseurChange
                                                  }
                                                  options={renderInvestisseursOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedInvestisseur ===
                                                      null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un investisseur..."
                                                />
                                                {(selectedInvestisseur ===
                                                  null ||
                                                  selectedInvestisseur ===
                                                    "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Investisseur ne peut pas
                                                    être vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Statut */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Statut
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedStatut}
                                                  onChange={handleStatutChange}
                                                  options={renderStatutOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedStatut === null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un statut..."
                                                />
                                                {(selectedStatut === null ||
                                                  selectedStatut === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Statut ne peut pas être vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Catégorie PME */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Catégorie PME
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedCategorie}
                                                  onChange={
                                                    handleCategorieChange
                                                  }
                                                  options={renderCategorieOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedCategorie === null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner une catégorie..."
                                                />
                                                {(selectedCategorie === null ||
                                                  selectedCategorie === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Catégorie ne peut pas être
                                                    vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Réservation */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Réservation
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  key={forceRender5}
                                                  value={selectedReservation}
                                                  onChange={
                                                    handleReservationChange
                                                  }
                                                  options={renderReservationOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner une réservation..."
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>

                                {/* Répartition réduction d'impôt */}
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleRepartitionAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <FiPercent size={16} className="me-2" />
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Répartition réduction d&apos;impôt
                                      </span>
                                    </div>
                                    {isRepartitionAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isRepartitionAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Nb actions réduction IR */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Nb actions réduction IR
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedNb_actions_ir}
                                                  onChange={handleNbIrChange}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                                <FiEdit3
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Nb actions réduction ISF */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Nb actions réduction ISF
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedNb_actions_isf}
                                                  onChange={handleNbIsfChange}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",

                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                                <FiEdit3
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Taux de réduction IR */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Taux de réduction IR
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedTauxReduction}
                                                  onChange={
                                                    handleTauxReductionChange
                                                  }
                                                  options={renderTauxReductionOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un taux IR..."
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Taux de réduction ISF */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Taux de réduction ISF
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedTauxReductionA}
                                                  onChange={
                                                    handleTauxReductionAChange
                                                  }
                                                  options={renderTauxReductionAOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un taux ISF..."
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>

                              {/* detail */}
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleDetailsSouscriptionAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Détails de la souscription
                                      </span>
                                    </div>
                                    {isDetailsSouscriptionAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isDetailsSouscriptionAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Date de souscription */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Date de souscription*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={
                                                    selectedDateSouscription
                                                  }
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  onChange={(dateString) =>
                                                    setSelectedDateSouscription(
                                                      dateString.target.value
                                                    )
                                                  }
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding:
                                                      "0.375rem 2rem 0.375rem 0.5rem",
                                                    height: "32px",
                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                                <FiCalendar
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </div>
                                              {selectedDateSouscription ===
                                                "" && (
                                                <div
                                                  className="mt-1"
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  Date de souscription ne peut
                                                  pas être vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Taux d'apport */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Taux d&apos;apport*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedTaux}
                                                  onChange={handleTauxChange}
                                                  options={renderTauxOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedTaux === null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un taux..."
                                                />
                                                {(selectedTaux === null ||
                                                  selectedTaux === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Taux d&apos;apport ne peut
                                                    pas être vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* PME */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  PME*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedPme}
                                                  onChange={handlePmeChange}
                                                  options={renderPmeOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedPme === null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner une PME..."
                                                />
                                                {(selectedPme === null ||
                                                  selectedPme === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    PME ne peut pas être vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Tranche */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Tranche*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  key={forceRender4}
                                                  value={selectedTranche}
                                                  onChange={handleTrancheChange}
                                                  options={renderTrancheOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedTranche === null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner une tranche..."
                                                />
                                                {(selectedTranche === null ||
                                                  selectedTranche === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Tranche ne peut pas être
                                                    vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Nb actions souscrites */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Nb actions souscrites
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedNbAction}
                                                  required
                                                  onChange={
                                                    handleNbActionChange
                                                  }
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",

                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                                <FiEdit3
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </div>

                                              {nbActionsMAx != null &&
                                                !isNaN(nbActionsMAx) &&
                                                nbActionsMAx > 0 && (
                                                  <div
                                                    className="mt-1"
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                      fontSize: 12,
                                                    }}
                                                  >
                                                    Max restant à ajouter :{" "}
                                                    {nbActionsMAx}
                                                  </div>
                                                )}

                                              {nbActionsMAx != null &&
                                                !isNaN(nbActionsMAx) &&
                                                nbActionsMAx < 0 && (
                                                  <div
                                                    className="mt-1"
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                      fontSize: 12,
                                                    }}
                                                  >
                                                    Attention, vous avez dépassé
                                                    le nombre d'actions possible
                                                    !
                                                  </div>
                                                )}

                                              {selectedNbAction === "" && (
                                                <div
                                                  className="mt-1"
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  Nb actions ne peut pas être
                                                  vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Nb actions restantes */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Nb actions restantes
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={nbActionsRestantes}
                                                  disabled
                                                  key={forceRender3}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Valeur action */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Valeur action (€)
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedValeurAction}
                                                  disabled
                                                  onChange={
                                                    handleValeurActionChange
                                                  }
                                                  key={forceRender0}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Montant souscription */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Montant souscription (€)
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedMtSouscription}
                                                  disabled
                                                  onChange={
                                                    handleMtSouscriptionChange
                                                  }
                                                  key={forceRender}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Mt. réservation restant */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Mt. réservation restant (€)
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedMtReservation}
                                                  disabled
                                                  onChange={
                                                    handleMtReservationChange
                                                  }
                                                  key={forceRender1}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Montant réduction impôt */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Montant réduction impôt (€)
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedMtReduction}
                                                  disabled
                                                  onChange={
                                                    handleMtReductionChange
                                                  }
                                                  key={forceRender2}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditReservation;
